import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {ResourceSubscriptionEnum} from '../../enums/billing';

@Component({
  selector: 'app-modal-not-allowed-by-suscription',
  templateUrl: './modal-not-allowed-by-suscription.component.html',
  styleUrls: ['./modal-not-allowed-by-suscription.component.scss']
})
export class ModalNotAllowedBySuscriptionComponent implements OnInit {

  @Input() isVisibleModal: boolean;
  @Input() resource: ResourceSubscriptionEnum;
  @Input() clinicId: string;
  @Output() closed: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al componente padre cuando se cierra el modal
   */
  onEmitClose(): void {
    this.closed.emit();
  }

  /**
   * Envía a la vista de planes en administración
   */
  onGotoPlans(): void {
    this.router.navigate(['clinic', this.clinicId, 'administration', 'plan']);
  }
}
